import * as coches from './coches/index.js'
import * as common from './common/index.js'
import * as motos from './motos/index.js'
import * as base from './base.js'
import development from './development.js'
import preproduction from './preproduction.js'
import production from './production.js'
import test from './test.js'

const stage = process.env.STAGE || process.env.NODE_ENV || 'production'
const isInternal = Boolean(process.env.INTERNAL)

console.log(`\nNODE_ENV: ${process.env.NODE_ENV}`) // eslint-disable-line no-console
console.log(`STAGE: ${stage}\n`) // eslint-disable-line no-console

/**
 * @exports APP_NAME_COCHES
 */
export const APP_NAME_COCHES = 'COCHES'

/**
 * @exports APP_NAME_MOTOS
 */
export const APP_NAME_MOTOS = 'MOTOS'

const envConfig = {
  development,
  preproduction,
  production,
  test
}
const appConfig = {
  [APP_NAME_MOTOS]: motos,
  [APP_NAME_COCHES]: coches
}

/**
 * @exports default Config
 */
export default class Config {
  /**
   * @constructor
   * @param {Object} deps
   * @param {String} deps.appName
   */
  constructor({appName}) {
    if (!appName) {
      return new Error('[Config#constructor] appName is empty')
    }

    const config = {
      ...base,
      ...common,
      ...envConfig[stage],
      ...appConfig[appName],
      ...appConfig[appName].environment[stage]
    }
    const {
      SECURED_ROOT_SUBDOMAIN,
      SECURED_API_ROUTE,
      HOST_NAME_DOMAIN,
      HOST_NAME_SUBDOMAIN,
      URL_PROTOCOL,
      API_SUBDOMAIN,
      API_DOMAIN,
      API_INTERNAL_URL,
      ADOBE_ACCOUNT_BASE,
      ADOBE_ACCOUNT_ENV,
      ADOBE_ACCOUNT_NAME
    } = config
    const HOST_NAME = `${HOST_NAME_SUBDOMAIN}${HOST_NAME_DOMAIN}`
    const ADOBE_ACCOUNT_URL = `${ADOBE_ACCOUNT_BASE}${ADOBE_ACCOUNT_NAME}${ADOBE_ACCOUNT_ENV}`
    const API_URL = isInternal ? API_INTERNAL_URL : `${URL_PROTOCOL}${API_SUBDOMAIN}${API_DOMAIN}`

    this._config = {
      ...config,
      APP_NAME_COCHES,
      APP_NAME_MOTOS,
      HOST_NAME,
      COMPANY_URL: `${URL_PROTOCOL}${HOST_NAME}`,
      ADOBE_ACCOUNT_URL,
      API_URL,
      APP_NAME: appName,
      SECURED_API_URL: `${URL_PROTOCOL}${SECURED_ROOT_SUBDOMAIN}${HOST_NAME_DOMAIN}${SECURED_API_ROUTE}`,
      IS_DEV: config.ENVIRONMENT !== production.ENVIRONMENT
    }
  }

  /**
   * @method
   * @param {String} key
   * @return {*}
   */
  get(key) {
    return this._config[key]
  }

  /**
   * @method
   * @param {String} key
   * @param {*} value
   * @return {*}
   */
  set(key, value) {
    this._config[key] = value
    return this
  }
}
